import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import htmlToLabel from "../../utils/htmlToLabel";

const FieldSettingsStepMapping = (props) => {
  const [contextData] = useContext(VariantContextData);

  let variant = props.variant;
  let step = props.step;
  let element = props.element;
  let field = props.field;

  let field_options = Object.values(contextData.objects.variant.field_options)
    .filter(
      (field_option) =>
        field_option.field_id == field.id && field_option.toBeDeleted !== true
    )
    .sort(function (a, b) {
      return a.position - b.position;
    });

  return (
    <React.Fragment>
      {field_options.map((field_option) => {
        const stepIdValid = ElementWarningsService.isValidRedirectStep(
          field_option.step_id,
          variant,
          step.id
        );
        const label = field_option.label
          ? htmlToLabel(field_option.label)
          : field_option.value;

        return (
          <div
            key={`field-option-mapping-${field_option.id}`}
            className="flex items-center gap-2 w-full mb-3"
          >
            <div
              className="min-w-0 w-[38%] shrink-0 bg-slate-100 dark:bg-slate-800 text-black dark:text-white text-xl px-3 py-2 rounded-md truncate"
              title={label}
            >
              {label}
            </div>
            <div className="shrink-0 text-xl text-slate-400">→</div>
            <div className="min-w-0 flex-1">
              <VariantBuilderSetting
                object={field_option}
                setting_name="[step_id]"
                setting_type="dropdown"
                object_type="field_options"
                object_id={field_option.id}
                value={stepIdValid ? field_option.step_id + "" : ""}
                options={[
                  {
                    value: "",
                    text: "Default funnel step",
                  },
                  ...Object.values(variant.steps)
                    .filter((s) => s.id !== step.id && s.toBeDeleted !== true)
                    .sort((a, b) => {
                      return a.position - b.position;
                    })
                    .map((s) => {
                      return {
                        value: s.id + "",
                        text:
                          "Step " +
                          s.position +
                          (s.options["name"] ? " - " + s.options["name"] : ""),
                      };
                    }),
                ]}
                condition={element.options["confirmation-type"] == "step"}
                warning={
                  field_option.step_id && !stepIdValid
                    ? "Step to jump to not yet set"
                    : undefined
                }
                classNames="!my-0 !px-0"
              />
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default FieldSettingsStepMapping;
